<template>
  <div
    class="tw-bg-white tw-text-primary-grey-800 tw-w-full tw-flex tw-items-center tw-p-4 tw-gap-4 tw-flex-col"
  >
    <slot name="image">
      <cl-icon-empty-box />
    </slot>
    <div class="tw-flex tw-flex-col tw-gap-2 tw-text-center">
      <div class="tw-font-medium tw-text-xl">
        <slot name="title" />
      </div>
      <div class="tw-text-sm"><slot name="description" /></div>
    </div>
  </div>
</template>
